import { useNavigate } from "react-router";

import { Segmentado } from "@/components/plantillas/etiquetas";

export const RUTA_DE_PLANTILLAS = "/admin/contenidos";
export const RUTA_DEL_MAESTRO = "/admin/contenidos/maestro";
export const RUTA_DE_FORMATOS = "/admin/contenidos/formatos";

export type VistaDelMantenedor = "plantillas" | "maestro" | "formatos";
type Vista = VistaDelMantenedor;

const RUTAS: Record<Vista, string> = {
  plantillas: RUTA_DE_PLANTILLAS,
  maestro: RUTA_DEL_MAESTRO,
  formatos: RUTA_DE_FORMATOS,
};

/**
 * El interruptor "Plantillas | Maestro de ítems | Formatos de salida" del
 * mantenedor. Son tres vistas con su propia ruta (y no un estado local) para que cada una se
 * pueda enlazar, recargar y volver con "atrás".
 */
export function ConmutadorDeVista({ vista }: { vista: Vista }) {
  const navigate = useNavigate();

  return (
    <Segmentado<Vista>
      etiqueta="Vista del mantenedor"
      valor={vista}
      onChange={(siguiente) => navigate(RUTAS[siguiente])}
      opciones={[
        { valor: "plantillas", etiqueta: "Plantillas", className: "px-3.5 text-[0.8125rem]" },
        { valor: "maestro", etiqueta: "Maestro de ítems", className: "px-3.5 text-[0.8125rem]" },
        { valor: "formatos", etiqueta: "Formatos de salida", className: "px-3.5 text-[0.8125rem]" },
      ]}
    />
  );
}
